import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { Globe } from 'lucide-react';

export function OpenPayeConfigCard() {
  return (
    <Card>
      <CardHeader title="OpenPaye" />
      <CardContent>
        <div className="flex items-center gap-3">
          <Globe className="h-8 w-8 text-warning-500" />
          <div>
            <p className="text-sm font-medium text-neutral-900 dark:text-neutral-200">Intégration OpenPaye</p>
            <Badge variant="success" className="mt-1">Connecté</Badge>
          </div>
        </div>
        <div className="mt-4 space-y-2 text-sm">
          <div className="flex justify-between text-neutral-600 dark:text-neutral-400">
            <span>URL</span><span className="text-neutral-900 dark:text-neutral-200 text-xs">openpaye.co</span>
          </div>
          <div className="flex justify-between text-neutral-600 dark:text-neutral-400">
            <span>Puppeteer</span><Badge variant="success">Opérationnel</Badge>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
